import { MARKET_PAIRS, type MarketPair } from '../data/mockMarket';
import { useLiveMarket } from './useLiveMarket';

export interface PairMetric {
  pair: MarketPair;
  price: number | undefined;
  change24h: number;
  volume24hUsd: number;
  tvlUsd: number | undefined;
  series: { t: number; price: number }[];
}

export function usePairMetrics(): { metrics: PairMetric[]; loading: boolean } {
  const metrics = MARKET_PAIRS.map((pair): PairMetric => {
    // MARKET_PAIRS is a fixed module constant, so hook call order cannot change.
    // oxlint-disable-next-line react-hooks/rules-of-hooks
    const market = useLiveMarket(pair);

    return {
      pair,
      price: market.price,
      change24h: market.change24h,
      volume24hUsd: market.volume24h,
      tvlUsd: market.liquidityUsd,
      series: market.series,
    };
  });

  return {
    metrics,
    loading: metrics.every((metric) => metric.price === undefined),
  };
}
